
















































































































import { Component, Vue } from 'vue-property-decorator';
import NavigationTab from '@/components/common/NavigationTab.vue';
import PreCollectionStore, {
  PreCollectionsParams,
  PreCollectionStoreInterface,
} from '@/resource/pre-collection/pre-collection.store';
import { Subject, SubjectType } from '@/resource/subject/subject.model';
import {
  PreCollectionSortBy,
  PreCollectionType,
  preCollectionTypeList,
} from '@/resource/pre-collection/pre-collection.model';
import PreCollectionSearch from '@/main-components/pre-collections-new/PreCollectionSearch.vue';
import PreCollectionFilter from '@/main-components/pre-collections-new/PreCollectionFilter.vue';
import PreCollectionSubject from '@/components/pre-collections/PreCollectionSubject.vue';
import PreCollectionItem from '@/main-components/pre-collections-new/PreCollectionItem.vue';
import PreCollectionNotFound from '@/components/pre-collections/PreCollectionNotFound.vue';
import PreCollectionNotAvail from '@/components/pre-collections/PreCollectionNotAvail.vue';
import PreCollectionLoading from '@/components/pre-collections/PreCollectionLoading.vue';
import PreCollectionFilterLoading from '@/components/pre-collections/PreCollectionFilterLoading.vue';
import { getAllSubjects } from '@/utils/add-question/add-question-util';
import getLevelPremadePaper from '@/utils/common/get-level-premade-paper';
import getFormByLevelPremade from '@/utils/common/get-form-by-label-premade';
import MainButton from '@/main-components/common/MainButton.vue';
import Img from '@/main-components/common/Img.vue';
import FilterSortBy from '@/main-components/pre-collections-new/pre-collection-filter/FilterSortBy.vue';
import PreCollectionHighlight from '@/main-components/pre-collections-new/PreCollectionHighlight.vue';
import ModalVideo from '@/main-components/common/modal/ModalVideo.vue';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import { pageSEO } from '@/utils/seo';
import seoDefault from '@/utils/seo-default';
import TestBanner from '@/main-components/common/TestBanner.vue';

export interface SubjectBlock {
  name: string;
  path: string;
  isAvailable: boolean;
}

export const delimiter = ',';

@Component({
  components: {
    NavigationTab,
    PreCollectionSearch,
    PreCollectionFilter,
    PreCollectionSubject,
    PreCollectionItem,
    PreCollectionNotFound,
    PreCollectionNotAvail,
    PreCollectionLoading,
    PreCollectionFilterLoading,
    Img,
    MainButton,
    FilterSortBy,
    PreCollectionHighlight,
    ModalVideo,
    TestBanner,
  },
  metaInfo(this: Browse): MetaInfo {
    return {
      title: pageSEO.title.setLatihan,
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: pageSEO.canonical.setLatihan,
        },
      ],
      meta: [
        ...seoDefault({
          title: pageSEO.titleMeta.setLatihan,
          description: pageSEO.description.setLatihan,
        }),
      ],
    };
  },
})
export default class Browse extends Vue {
  preCollectionStore: PreCollectionStoreInterface = PreCollectionStore;

  isLoading = true;
  isLoadingSubject = true;
  isLoadingAddPreCollection = false;
  openVideoTutorialModal: any = null;

  queries: PreCollectionsParams = this.resetQueries();

  availSubjects: Subject[] = [];

  get preCollections() {
    return this.preCollectionStore.preCollections;
  }

  get selectedSubject() {
    return this.availSubjects.find(
      availSubject => availSubject.uuid === this.queries.subjectUuid,
    );
  }

  get isLastPage() {
    const { pagination } = this.preCollectionStore;
    return pagination.page >= pagination.totalPages;
  }

  get totalResults() {
    const { pagination } = this.preCollectionStore;
    return pagination.totalRecords;
  }

  get subjectQuery(): string {
    let subjectQuery = '';
    if (typeof this.$route.query['subject'] === 'string') {
      subjectQuery = this.$route.query['subject'];
    }
    return subjectQuery;
  }

  get typeQuery(): SubjectType {
    let typeQuery = SubjectType.All;
    if (typeof this.$route.query['type'] === 'string') {
      typeQuery = this.$route.query['type'] as SubjectType;
    }
    return typeQuery;
  }

  get levelQuery() {
    let levelQuery: string[] | null = null;
    if (typeof this.$route.query['level'] === 'string') {
      levelQuery = this.$route.query['level'].split(delimiter);
    }

    return levelQuery?.length
      ? levelQuery.map(level => {
          return getFormByLevelPremade(level, '_') as number;
        })
      : null;
  }

  get paperTypeQuery(): PreCollectionType[] | null {
    let paperTypeQuery: PreCollectionType[] | null = null;
    if (typeof this.$route.query['paper'] === 'string') {
      paperTypeQuery = this.$route.query['paper'].split(
        delimiter,
      ) as PreCollectionType[];
    }
    return paperTypeQuery;
  }

  get keywordQuery() {
    let keywordQuery = '';
    if (typeof this.$route.query['keyword'] === 'string') {
      keywordQuery = this.$route.query['keyword'];
    }
    return keywordQuery;
  }

  get yearQuery() {
    let yearQuery: string[] | null = null;
    if (typeof this.$route.query['year'] === 'string') {
      yearQuery = this.$route.query['year'].split(delimiter);
    }

    return yearQuery?.length
      ? yearQuery.map(year => {
          return parseInt(year);
        })
      : null;
  }

  get dropdownSubjectInput() {
    return {
      name: 'subject',
      value: {
        selectedSubject: this.queries.subjectUuid,
        selectedForm: this.queries.levels,
        selectedChapter: null,
        selectedChapters: [],
      },
      type: 'dropdown-subject',
      isRequired: true,
      isFormRequired: true,
      isHideChapter: true,
    };
  }

  beforeCreate() {
    this.$timeMpEvent(this.$mp_value.LoadTimePreCollections);
  }

  async created() {
    if (this.subjectQuery) {
      this.queries.subjectUuid = this.subjectQuery;
    }

    if (this.levelQuery) {
      this.queries.levels = this.levelQuery;
    }

    if (this.paperTypeQuery) {
      this.queries.preCollectionTypes = this.paperTypeQuery;
    }

    if (this.keywordQuery) {
      this.queries.keyword = this.keywordQuery;
    }

    if (this.yearQuery) {
      this.queries.years = this.yearQuery;
    }

    this.availSubjects = await getAllSubjects();
    this.isLoadingSubject = false;
  }

  async firstFetch() {
    this.isLoading = true;

    this.preCollectionStore.pagination.page = 1;
    this.preCollectionStore.pagination.isResetPage = true;
    this.preCollectionStore.pagination.limit = 6;

    await this.preCollectionStore.fetchPreCollections(this.queries);
    this.updateQueryUrl();

    this.isLoading = false;
    this.$sendMpEvent({
      event: this.$mp_value.PremadePaperSearch,
      properties: {
        ...this.queries,
        totalPremadePapers: this.preCollections.length,
      },
    });

    this.$sendMpEvent({
      event: this.$mp_value.LoadTimePreCollections,
    });
  }

  async reFetch(isChangeQuery: boolean) {
    if (this.isLoading) return;
    this.isLoading = true;

    this.preCollectionStore.pagination.page = 1;
    this.preCollectionStore.pagination.isResetPage = true;
    await this.preCollectionStore.fetchPreCollections(this.queries);

    if (isChangeQuery) {
      this.updateQueryUrl();
    }

    this.isLoading = false;
    this.$sendMpEvent({
      event: this.$mp_value.PremadePaperSearch,
      properties: {
        ...this.queries,
        totalPremadePapers: this.preCollections.length,
      },
    });
  }

  async addFetch() {
    if (this.isLoading || this.isLoadingAddPreCollection) return;
    this.isLoadingAddPreCollection = true;

    this.preCollectionStore.pagination.page += 1;
    await this.preCollectionStore.fetchPreCollections(this.queries);

    this.isLoadingAddPreCollection = false;
    this.$sendMpEvent({
      event: this.$mp_value.PremadePaperLoadMore,
      properties: {
        ...this.queries,
        totalPremadePapers: this.preCollections.length,
      },
    });
  }

  resetFilters() {
    this.queries.keyword = '';
    this.queries.sortBy = PreCollectionSortBy.Latest;
    this.queries.preCollectionTypes = preCollectionTypeList;
    this.queries.years = [];
    this.queries.levels = [];

    this.reFetch(true);
  }

  resetQueries() {
    const resetValue = {
      subjectUuid: this.subjectQuery ? this.subjectQuery : 'all',
      keyword: this.keywordQuery,
      subjectType: SubjectType.All,
      sortBy: PreCollectionSortBy.Latest,
      preCollectionTypes: preCollectionTypeList,
      years: this.yearQuery ? this.yearQuery : [],
      levels: this.levelQuery ? this.levelQuery : [],
    };

    this.queries = resetValue;

    return resetValue;
  }

  updateQueryUrl() {
    const queryUrls = {
      subject: this.queries.subjectUuid,
    };

    if (!this.queries.subjectUuid) {
      queryUrls.subject = 'all';
    }

    if (this.queries.levels.length) {
      queryUrls['level'] = null;
      const levels = this.queries.levels.map(level => {
        return getLevelPremadePaper(level)
          .replaceAll(' ', '_')
          .toLowerCase();
      });

      queryUrls['level'] = levels.join(delimiter);
    } else {
      queryUrls['level'] = null;
      delete queryUrls['level'];
    }

    if (this.queries.preCollectionTypes.length) {
      queryUrls['paper'] = this.queries.preCollectionTypes.join(delimiter);
    } else {
      queryUrls['paper'] = null;
      delete queryUrls['paper'];
    }

    if (this.queries.keyword) {
      queryUrls['keyword'] = this.queries.keyword;
    } else {
      queryUrls['keyword'] = null;
      delete queryUrls['keyword'];
    }

    if (this.queries.years.length) {
      queryUrls['year'] = this.queries.years.join(delimiter);
    } else {
      queryUrls['year'] = null;
      delete queryUrls['year'];
    }

    let isSameQuery = false;

    if (
      this.$route.query.subject === queryUrls.subject &&
      this.$route.query.level === queryUrls['level'] &&
      this.$route.query.paper === queryUrls['paper'] &&
      this.$route.query.keyword === queryUrls['keyword'] &&
      this.$route.query.year === queryUrls['year']
    ) {
      isSameQuery = true;
    }

    if (!isSameQuery) {
      this.$router.push({
        path: this.$router.currentRoute.path,
        query: {
          ...queryUrls,
        },
      });
    }
  }

  openVideoTutorialModalAdd(openModal: any) {
    this.openVideoTutorialModal = openModal;
  }

  tutorialClick() {
    this.$sendMpEvent({
      event: this.$mp_value.VideoBrowseClick,
    });

    this.openVideoTutorialModal && this.openVideoTutorialModal();
  }
}
